import { render } from "./AppFooter.vue?vue&type=template&id=19e5d21f&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e5d21f"]])

export default __exports__